import { OtherReports, AllReports } from "../../components";

function Reports() {
    return (
        <div className='section-container md:py-2 py-0 space-y-4'>
            <div className='bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 rounded-xl shadow-sm overflow-hidden'>
                <div className='px-6 py-4 border-b border-gray-100 dark:border-gray-700'>
                    <h2 className='text-base font-semibold text-gray-900 dark:text-gray-50'>Generate Reports</h2>
                    <p className='text-sm text-gray-500 dark:text-gray-400 mt-0.5'>Export data by report type and date range.</p>
                </div>

                <div className="overflow-x-auto">
                    <table className='min-w-full'>
                        <thead className='text-xs font-semibold tracking-wide text-left text-gray-400 dark:text-gray-500 uppercase border-b border-gray-100 dark:border-gray-700 bg-gray-50/60 dark:bg-gray-900/60'>
                            <tr>
                                <th className='px-6 py-3 md:w-[40%]'>Report Type</th>
                                <th className='px-6 py-3 md:w-[40%]'>Date (End)</th>
                                <th className='px-6 py-3 md:w-[20%]'>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <AllReports />
                        </tbody>
                    </table>
                </div>
            </div>

            <div className='bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 rounded-xl shadow-sm overflow-hidden'>
                <div className='px-6 py-4 border-b border-gray-100 dark:border-gray-700'>
                    <h2 className='text-base font-semibold text-gray-900 dark:text-gray-50'>Date Range Reports</h2>
                    <p className='text-sm text-gray-500 dark:text-gray-400 mt-0.5'>Generate reports across a custom date range.</p>
                </div>

                <div className="overflow-x-auto">
                    <table className='min-w-full'>
                        <thead className='text-xs font-semibold tracking-wide text-left text-gray-400 dark:text-gray-500 uppercase border-b border-gray-100 dark:border-gray-700 bg-gray-50/60 dark:bg-gray-900/60'>
                            <tr>
                                <th className='px-6 py-3 md:w-[25%]'>Report Type</th>
                                <th className='px-6 py-3 md:w-[25%]'>From Date</th>
                                <th className='px-6 py-3 md:w-[25%]'>To Date</th>
                                <th className='px-6 py-3 md:w-[25%]'>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <OtherReports />
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default Reports;
